export default () => {

  const $btn = $('.js-menu');
  $btn.on('click.openMenu' , function(){
    const $nav = $('.p-nav');
    const $list = $('.p-nav_list');

    if ($nav.hasClass('is-open')) {
      $nav.removeClass('is-open');
      // $('.js-accordion').removeClass('is-open');
      // $('.js-accordion-child').slideUp('fast');
    }else{
      $nav.addClass('is-open');
    }
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/utilities/mobileMenu.js